import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../../graphql/types.generated';
export type UpdateCargoDescriptionMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.UpdateCargoDescriptionInput;
}>;

export type UpdateCargoDescriptionMutationResult = { __typename?: 'Mutation' } & {
  updateCargoDescription: { __typename?: 'UpdateCargoDescriptionPayload' } & {
    errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
  };
};

export const UpdateCargoDescriptionDocument = gql`
  mutation updateCargoDescription($input: UpdateCargoDescriptionInput!) {
    updateCargoDescription(input: $input) {
      errors {
        message
        path
      }
    }
  }
`;
